exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-destination-card{border-radius:16px!important;height:230px!important}.top-destinations-btn{height:46px!important;box-shadow:unset!important;width:144px;color:#000!important;text-transform:none}", ""]);

// exports
